import { render } from "./favoritos.vue?vue&type=template&id=64464f97&scoped=true"
import script from "./favoritos.vue?vue&type=script&lang=js"
export * from "./favoritos.vue?vue&type=script&lang=js"

import "./favoritos.vue?vue&type=style&index=0&id=64464f97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64464f97"]])

export default __exports__